// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js","976":"c16184b3"}[chunkId] || chunkId) + "-" + {"678":"4b3c2ee8603364350ea5","731":"3cb6be29e94a2b228fa5","843":"d06b4bbb8a9204fea2fa","883":"3b5df53b1a6dc51ef714","976":"119b42e801d75bc6192e"}[chunkId] + ".js";
};